import createCRUDObservable from 'redux-observable-crud'
import { Observable } from 'rxjs'
import { combineEpics } from 'redux-observable'
import { clone } from 'ramda'
import CompaniesAction, { CompaniesRedux, CompaniesTypes } from '../Redux/CompaniesRedux'
import { ContactsRedux } from '../Redux/ContactsRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const companiesCrudObservable = createCRUDObservable({
  mainRedux: CompaniesRedux,
  reduxPath: 'companies',
  dataHandlers: {
    get: response => response.data,
  },
})
// const setProductsEpic = (action$,store) => (
//   action$.ofType(CompaniesTypes.setParamters)
//     .flatMap(() => {

//       const data = clone(store.getState().companies.getOne.result)
//       const countries = clone(store.getState().countries.get.results)
//       const countryProduct = countries.filter(countrys => countrys.id === data.country.id)
//       return [
//         CompaniesAction.setAvailableProducts(countryProduct[0].products),
//         CompaniesAction.setAvailableCenters(countryProduct[0].centers)
//       ]
//     })
// )
const getAvailableCentersEpic = (action$, store, { Api }) =>
  action$
    .ofType(CompaniesRedux.Types.getAvailableCentersRequest)
    .mergeMap(({ id }) => (
      Api.companies.getAvailableCenters(id)
        .then(response => response.data.data)
        .then(result => CompaniesRedux.Creators.getAvailableCentersSuccess(result))
        .catch(error => CompaniesRedux.Creators.getOneFailure(error))
    ))

const getPaymentTypesEpic = (action$, store, { Api }) =>
  action$
    .ofType(CompaniesRedux.Types.getPaymentTypesRequest)
    .mergeMap(({ id }) => (
      Api.companies.getPaymentTypes()
        .then(response => response.data.data)
        .then(result => CompaniesRedux.Creators.getPaymentTypesSuccess(result))
        .catch(error => CompaniesRedux.Creators.getPaymentTypesError(error))
    ))

const createCompanyContactEpic = (action$, store, { Api }) =>
  action$
    .ofType(CompaniesRedux.Types.contactsCreateRequest)
    .mergeMap(({ data, company_id }) => (
      Api.companies.createCompanyContact(company_id, data)
        .then(response => response.data.data)
        .then(result => ContactsRedux.Creators.createSuccess(result))
        .catch(error => ContactsRedux.Creators.createFailure(error))
    ))

const createContractEpic = (action$, store, { Api }) =>
  action$.ofType(CompaniesRedux.Types.contractCreateRequest).mergeMap(({ id, data }) =>
    Observable.fromPromise(
      Api.companies.createContract(id, data)
        .then(response => response)
        .catch(error => error),
    ).flatMap((response) => {
      const { status } = response
      if (!(status >= 200 && status < 300)) {
        return [
          CompaniesRedux.Creators.contractCreateError(response.error),
          notificationFail('Error', response.error),
        ]
      }
      const result = response.data.data
      return [
        notificationSuccess('Exitosa', 'Informacion Guardada Exitosamente.'),
        CompaniesRedux.Creators.contractCreateSuccess(result),
      ]
    },
    ),
  )

const updateInvoiceDetailsEpic = (action$, store, { Api }) =>

  action$.ofType(CompaniesRedux.Types.updateInvoiceDetailsRequest).mergeMap(({ id, data }) =>

    Observable.fromPromise(

      Api.companies.updateInvoiceDetails(id, data)

        .then(response => response)

        .catch(error => error),

    ).flatMap((response) => {
      const { status } = response

      if (!(status >= 200 && status < 300)) {
        return [

          CompaniesRedux.Creators.updateFailure(error),

          notificationFail('Error', response.error),

        ]
      }

      const result = response.data.data

      return [

        notificationSuccess('Exitosa', 'Informacion Guardada Exitosamente.'),

        CompaniesRedux.Creators.updateInvoiceDetailsSuccess(result),

      ]
    },

    ),

  )

export const companiesObservers = Object.assign({}, companiesCrudObservable.observers, {
  createCompanyContactEpic,
  createContractEpic,
  getAvailableCentersEpic,
  updateInvoiceDetailsEpic,
  getPaymentTypesEpic,
  // setProductsEpic,
})

export const companiesEpic = combineEpics(
  companiesCrudObservable.epic,
  createCompanyContactEpic,
  createContractEpic,
  getAvailableCentersEpic,
  updateInvoiceDetailsEpic,
  getPaymentTypesEpic,
  // setProductsEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/CompaniesObservable.js